import styled from "styled-components";
import Fundo from '../img/Fundo_Impressora.png';

export const DivImpressoras = styled.div`
    position: relative;
    margin: 2vh auto 0;
    width: 85.9%;
    aspect-ratio: 1920 / 594;
    overflow: hidden;
    border-radius: 6px;
    border: 2px solid #d5d5d5;
    box-sizing: border-box;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    background-image: url(${Fundo});
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;

    .conteudo {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        padding: 2% 5%;
        box-sizing: border-box;
    }

    .coluna-esquerda {
        width: 62%;
    }

    h1 {
        margin: 0 0 1.5% 0;
        font-size: 3.0vw;
        font-weight: 800;
        color: #171717;
    }

    p {
        margin: 0 0 2.5%;
        font-size: 1.1vw;
        line-height: 1.4;
        color: #262626;
        font-weight: 500;
    }

    .marcas {
        display: flex;
        align-items: center;
        gap: 2vw;

        img {
            width: 8vw;
            object-fit: contain;
        }
    }

    .logo-canto {
        position: absolute;
        right: 5%;
        bottom: 8%;

        img {
            width: 6vw;
        }
    }

    .linha-final {
        position: absolute;
        left: 5%;
        bottom: 6%;
        width: 32%;
        height: 0.3vw;
        background-color: #F5A623;

        .quadrado {
            position: absolute;
            top: 50%;
            right: -1vw;
            transform: translateY(-50%);
            width: 1vw;
            height: 1vw;
            background-color: #F5A623;
        }
    }

    @media screen and (max-width: 750px) {
        aspect-ratio: auto;
        width: 100%;
        margin: 0px;
        border-radius: 0px;

        .conteudo {
            position: static;
            flex-direction: column;
            padding: 6vw 5vw 10vw;
        }

        .coluna-esquerda {
            width: 100%;
            text-align: center;
        }

        h1 {
            font-size: 7vw;
        }

        p {
            font-size: 3.5vw;
        }

        .marcas {
            justify-content: center;
            flex-wrap: wrap;
            row-gap: 4vw;

            img {
                width: 22vw;
            }
        }

        .logo-canto {
            position: static;
            margin-top: 5vw;

            img {
                width: 22vw;
            }
        }

        .linha-final {
            display: none;
        }
    }
`;
